import styled from "styled-components";

export const modalAlert = styled.div`
  .modal-alert {
    font-size: 19px;
    color: ${({ theme }) => theme.cor41}!important;
  }
`;
